import React, { useEffect, useState } from "react";
import moment from "moment";

import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
} from "antd";

import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
   EyeOutlined,
} from "@ant-design/icons";

import { ConfigProvider } from "antd";


const CarteiraTrabalhoForm = ({
  form,
  nomePrefix,
  isCarteiraTrabalho,
  camposBloqueados,
  getScrollableParent,
  setCarteiraSelecionada,
  setModalCarteiraAberto,
  carteiraSelecionada,
  carteiraTrabalho,
  onSalvarCarteira,
  onExcluirCarteira,
  modoSomenteLeitura,
  origemCarteira ,
}) => {

  const ehDependente = origemCarteira === "DEPENDENTE";
  const campoCarteira = [
    ...nomePrefix,
    "carteiraTrabalho",
  ];


  const campoLista = [
    ...nomePrefix,
    "carteirasTrabalho",
  ];

  const [mostrarLista, setMostrarLista] = useState(
    (modoSomenteLeitura || ehDependente) &&
    form.getFieldValue(campoLista)?.length > 0
  );

  const [validarCarteira, setValidarCarteira] = useState(isCarteiraTrabalho);

  const [listaCarteiras, setListaCarteiras] = useState(
    form.getFieldValue(campoLista) || []
  );


  useEffect(() => {

      if (!carteiraSelecionada) {
        return;
      }

      form.setFieldValue(campoCarteira, {
        numero: carteiraSelecionada.numero?.trim() || "",
        serie: carteiraSelecionada.serie?.trim() || "",
        localExpedicao:
          carteiraSelecionada.localExpedicao?.trim() || "",
        dataExpedicao: carteiraSelecionada.dataExpedicao
          ? moment(carteiraSelecionada.dataExpedicao)
          : null,
      });

    }, [carteiraSelecionada]);

    useEffect(() => {

    const lista = form.getFieldValue(campoLista) || [];

    if ((modoSomenteLeitura || ehDependente) && lista.length > 0) {
      setListaCarteiras(lista);
      setMostrarLista(true);
    }

  }, [modoSomenteLeitura,ehDependente]);

  
  useEffect(() => {
    if (!ehDependente) {
      return;
    }

    const lista = form.getFieldValue(campoLista) || [];

    setListaCarteiras(lista);
    setMostrarLista(lista.length > 0);
  }, [
    ehDependente,
    form,
    carteiraTrabalho
  ]);
  


  const excluirCarteira = async (index) => {

    const carteiraExcluida = listaCarteiras[index];


    try {

      // primeiro remove no backend
      if (
        carteiraExcluida?.id &&
        onExcluirCarteira
      ) {

        await onExcluirCarteira(
          carteiraExcluida.id
        );

      }


      // somente se o backend deu sucesso remove da tela
      const novaLista = listaCarteiras.filter(
        (_, i) => i !== index
      );


      form.setFieldValue(
        campoLista,
        novaLista
      );

      setListaCarteiras(novaLista);


      if (novaLista.length === 0) {

        setMostrarLista(false);

        if (isCarteiraTrabalho) {
          setValidarCarteira(true);
        }

      }


      message.success(
        "Carteira excluída com sucesso."
      );


    } catch(error) {

      console.error(error);

      message.error(
        "Erro ao excluir a carteira."
      );

      // mantém a carteira na tela

    }

  };

  const adicionarCarteira = async () => {
  const valores = form.getFieldValue(campoCarteira) || {};

  const numero = valores.numero?.trim();
  const serie = valores.serie?.trim();
  const localExpedicao = valores.localExpedicao?.trim();
  const dataExpedicao = valores.dataExpedicao;

  /* Verifica se algum campo da carteira foi preenchido. */
  const algumCampoPreenchido =
    numero ||
    serie ||
    localExpedicao ||
    dataExpedicao;

  /*Se nenhum campo foi preenchido, não permite realizar a ação. */
  if (!algumCampoPreenchido) {
    message.warning(
      "Preencha os campos da Carteira de Trabalho para realizar a ação."
    );

    return;
  }

  /*Se qualquer campo foi preenchido,todos os campos passam a ser obrigatórios. */
  const todosCamposPreenchidos =
    numero &&
    serie &&
    localExpedicao &&
    dataExpedicao;

  if (!todosCamposPreenchidos) {
    message.warning(
      "Preencha todos os campos da Carteira de Trabalho para realizar a ação."
    );

    return;
  }

  /* Mantém a validação das regras existentes */
  try {
    await form.validateFields([
      [...campoCarteira, "numero"],
      [...campoCarteira, "serie"],
      [...campoCarteira, "dataExpedicao"],
      [...campoCarteira, "localExpedicao"],
    ]);
  } catch {
    return;
  }

  const novaCarteira = {
    ...(carteiraSelecionada || {}),
    ...valores,
    numero,
    serie,
    localExpedicao,
    dataExpedicao: dataExpedicao.format("YYYY-MM-DD"),
  };

  /* 1 - valida duplicidade somente na tela */
  const existe = listaCarteiras.some((item, indice) => {
    if (
      carteiraSelecionada &&
      carteiraSelecionada.index === indice
    ) {
      return false;
    }

    return (
      String(item.numero || "").trim() ===
      numero
    );
  });

  if (existe) {
    message.warning(
      "Já existe uma carteira cadastrada."
    );

    limparCarteira();
    setMostrarLista(true);
    setValidarCarteira(false);

    return;
  }

  try {
    /*2 - salva no backend primeiro*/
    let carteiraSalva = novaCarteira;

    if (onSalvarCarteira) {
      carteiraSalva = await onSalvarCarteira(
        novaCarteira
      );
    }

    /* 3 - somente depois do sucesso altera a tela*/
    const novaLista = [...listaCarteiras];

    if (
      carteiraSelecionada &&
      carteiraSelecionada.index !== undefined
    ) {
      novaLista[
        carteiraSelecionada.index
      ] = carteiraSalva;
    } else {
      novaLista.unshift(carteiraSalva);
    }

    form.setFieldValue(
      campoLista,
      novaLista
    );

    setListaCarteiras(novaLista);

    setMostrarLista(true);

    setValidarCarteira(false);

    /*4 - limpa somente depois do sucesso*/
    limparCarteira();

    setCarteiraSelecionada(null);

  } catch (error) {
    console.error(error);

    message.error(
      "Erro ao salvar a carteira de trabalho."
    );
  }
};

  const limparCarteira = () =>{
    form.setFieldValue(campoCarteira, {
      numero: null,
      serie: null,
      dataExpedicao: null,
      localExpedicao: null,
    });
  }

  const limparVisualizacaoCarteira = () => {

    form.setFieldsValue({
      [nomePrefix[0]]: {
        [nomePrefix[1]]: {
          carteiraTrabalho: {
            numero: "",
            serie: "",
            dataExpedicao: null,
            localExpedicao: "",
          },
        },
      },
    });

    setCarteiraSelecionada(null);

  };


  return (
    <Col span={20}>
      <fieldset
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: 6,
          padding: 12,
          height: mostrarLista ? 300 : "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <legend
          style={{
            fontSize:13,
            fontWeight:600
          }}
        >
          Carteira de Trabalho
        </legend>

        <Row gutter={16}>
          <Col span={5}>
            <Form.Item
              name={[
                ...campoCarteira,
                "numero"
              ]}
              label="Número"
              rules={[
                    {
                    required: validarCarteira,
                    message: "Informe o Número da Carteira de Trabalho.",
                    },
                    {
                    max: 8,
                    message: "Máximo de 8 caracteres.",
                    },
               ]}
            >
              <Input
                disabled={
                  modoSomenteLeitura ||
                  (camposBloqueados && !isCarteiraTrabalho)
                }
                maxLength={8}
              />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              name={[
                ...campoCarteira,
                "serie"
              ]}
              label="Série"
              rules={[
                    {
                    required: validarCarteira,
                    message: "Informe a Série da Carteira de Trabalho.",
                    },
                    {
                    max: 5,
                    message: "Máximo de 5 caracteres.",
                    },
              ]}
            >
              <Input
                disabled={
                  modoSomenteLeitura ||
                  (camposBloqueados && !isCarteiraTrabalho)
                }
                 maxLength={5}
              />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              name={[
                ...campoCarteira,
                "dataExpedicao"
              ]}
              label="Data Expedição"
              rules={[
                    {
                    required: validarCarteira,
                    message: "Informe a Data de Expedição.",
                    },
              ]}
            >
              <DatePicker
                style={{
                  width:"100%"
                }}
                disabled={modoSomenteLeitura}
                format="DD/MM/YYYY"
                getPopupContainer={
                  getScrollableParent
                }
                disabledDate={(current) =>
                  current && current > moment().endOf("day")
                }
              />
            </Form.Item>
          </Col>

          <Col span={5}>
            <Form.Item
              name={[
                ...campoCarteira,
                "localExpedicao"
              ]}
              label="Local"
              rules={[
                {
                required: validarCarteira,
                message: "Informe o Local de Expedição.",
                },
                {
                max: 100,
                message: "Máximo de 100 caracteres.",
                },
              ]}
            >
              <Input  disabled={
                  modoSomenteLeitura ||
                  (camposBloqueados && !isCarteiraTrabalho)
                }
              />
            </Form.Item>
          </Col>

          {
            !modoSomenteLeitura && (
              <Col span={4}>
                <Form.Item label=" ">
                  <Button
                    type="primary"
                    icon={<PlusOutlined/>}
                    block
                    onClick={adicionarCarteira}
                  >
                    Salvar
                  </Button>
                </Form.Item>
              </Col>
            )
          }
          
        </Row>
       {mostrarLista && ( <div
          style={{
            flex:1,
            minHeight:0,
            overflowY:"auto",
            overflowX:"hidden",
            marginTop:8,
          }}
        >
          <Table
            size="small"
            pagination={false}
            rowKey={(_,index)=>index}
            dataSource={listaCarteiras}
            columns={[
              {
                title:"Número",
                dataIndex:"numero",
                width:100,
              },
              {
                title:"Série",
                dataIndex:"serie",
                width:100,
              },
              {
                title:"Data Exp.",
                dataIndex:"dataExpedicao",
                width:110,
                render:(data)=>
                  data
                    ? moment(data)
                        .format("DD/MM/YYYY")
                    : "",
              },
              {
                title:"Local",
                dataIndex:"localExpedicao",
                ellipsis:true,
              },
              {
                title: "Ações",
                width: 120,
                render: (_, item, index) => (
                  <Space>

                    {modoSomenteLeitura && (
                      <Button
                        type="link"
                        icon={<EyeOutlined />}
                        title="Visualizar"
                        disabled={false}
                        onClick={() => {

                          const carteira = {
                            ...item,
                            index
                          };

                          setCarteiraSelecionada(carteira);

                          form.setFieldValue(campoCarteira, {
                            numero: carteira.numero,
                            serie: carteira.serie,
                            localExpedicao: carteira.localExpedicao,
                            dataExpedicao: carteira.dataExpedicao
                              ? moment(carteira.dataExpedicao)
                              : null,
                          });

                          setModalCarteiraAberto(true);
                        }}
                      />
                    )}

                    {!modoSomenteLeitura && (
                      <>
                        <Button
                          type="link"
                          icon={<EditOutlined />}
                          title="Editar"
                          onClick={() => {

                            const carteira = {
                              ...item,
                              index
                            };

                            setCarteiraSelecionada(carteira);

                            form.setFieldValue(campoCarteira, {
                              numero: carteira.numero,
                              serie: carteira.serie,
                              localExpedicao: carteira.localExpedicao,
                              dataExpedicao: carteira.dataExpedicao
                                ? moment(carteira.dataExpedicao)
                                : null,
                            });

                            setModalCarteiraAberto(true);
                          }}
                        />

                        <Popconfirm
                          title="Excluir carteira?"
                          onConfirm={() => excluirCarteira(index)}
                        >
                          <Button
                            type="link"
                            danger
                            icon={<DeleteOutlined />}
                            title="Excluir"
                          />
                        </Popconfirm>
                      </>
                    )}

                  </Space>
                )
              }
            ]}
          />
        </div>)}
      </fieldset>
    </Col>
  );

};


export default CarteiraTrabalhoForm;